import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { CustomToastService } from '@app-shared/services';

@Component({
  selector: 'dcamount-inconsistent-withdb-alert.component',
  templateUrl: './dcamount-inconsistent-withdb-alert.component.html',
  styleUrls: ['./dcamount-inconsistent-withdb-alert.component.sass']

})

export class DCAmountInconsistentComponent implements OnInit {  
  
  @Input() title: string;
  @Input() cmsModel;
  @Output() goToDcLandingEvent:EventEmitter<boolean> = new EventEmitter<boolean>();
  topBorderClass: string;
    
  constructor(private router: Router, public activeModal: NgbActiveModal, 
    private modalService: NgbModal,private toastr: CustomToastService) {
  }

  ngOnInit() {
    this.toastr.remove();
    this.topBorderClass = `top-border-red`;
  }

  goToDcLanding() {
    this.goToDcLandingEvent.emit(true);
    this.activeModal.close(true)
  }
}

